module.exports = __webpack_public_path__ + "right-arrow-nav.00c65e4c94caa466bfdf6a2e20bfe8c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/right-arrow-nav.svg
// module id = 408
// module chunks = 0